import { useAuth, useOrganizationList } from '@clerk/nextjs';
import React from 'react';

function SyncActiveUserOrg() {
  const { setActive, isLoaded, userMemberships } = useOrganizationList({ userMemberships: true });
  const { orgId } = useAuth();

  React.useEffect(() => {
    if (!isLoaded) return;
    if (orgId) return;
    if (!userMemberships.count) return;

    setActive({
      organization: userMemberships.data[0].organization.id,
    });
  }, [isLoaded, orgId, userMemberships, setActive]);

  return null;
}

export { SyncActiveUserOrg };
